import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import * as PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

const hideErrorModal = hideModal(modalTypes.ERROR);

const ErrorModal = ({
  errorMessage,
  handleOk = hideErrorModal,
  title = "Unexpected error occurred",
}) => {
  const dispatch = useDispatch();

  if (errorMessage === null) {
    return null;
  }

  const onDismiss = () => {
    dispatch(hideErrorModal);
  };

  const dispatchHandleOk = () => {
    dispatch(handleOk);
  };

  return (
    <Modal
      data-testid="error-modal"
      className="fade-in"
      show
      centered
      onDismiss={onDismiss}
    >
      <Modal.Header>
        <b>{title}</b>
      </Modal.Header>
      <Modal.Body>{errorMessage}</Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="okButton"
          variant={NewButtonVariant.l1}
          onClick={dispatchHandleOk}
        >
          Ok
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;

ErrorModal.propTypes = {
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handleOk: PropTypes.func.isRequired,
  title: PropTypes.string,
};
